module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/Immediate-aee45fa863fcd01828e22cfe023f41f4.png";